import { OriCheckbox } from '@/src/components/Antd';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import { Field, itemWrapperErrorDisplayAdaptor } from 'src/components/RcForm';
import Uploader from 'src/constrains/SingleImageUploader';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  imageAutoplayEnabled,
  imageBackground,
  imageImage,
  imageImageLink,
  imageMute,
  imageSetting,
} from 'src/tools/contentModulesFieldName';
import { mediaTypeCheck } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { MediaType } from 'src/types/common/common';
import css from './css.module.less';
const ImageAndVideo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { validators, breakpoint } = props;
  const imageValidator = get(validators, 'image');
  const linkValidator = get(validators, 'link');

  const _params: any = useParams();
  const { contentUuid } = _params;
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  const renderUnderMedia = (type) => {
    if (type === MediaType.Image) {
      return (
        <React.Fragment>
          <Field
            shouldUpdate={(p, c) => {
              return get(p, `${imageImage}`) !== get(c, `${imageImage}`);
            }}>
            {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
              const image = getFieldValue(imageImage);
              return (
                <Field name={[imageImage, imageSetting]}>
                  {(props, meta) => {
                    //const value = props.value;
                    const onChange = props.onChange;
                    return (
                      <FocusPoint
                        image={image}
                        onChange={(image) => {
                          onChange(get(image, 'image.imageSetting'));
                        }}
                      />
                    );
                  }}
                </Field>
              );
            }}
          </Field>
          <Field
            name={imageImageLink}
            rules={[
              {
                // validateTrigger: 'onSubmit',
                validator: async (rules: any, value: any) => {
                  if (linkValidator) {
                    const res = linkValidator(value, { breakpoint });

                    const hasError = get(res, 'hasError');
                    const errors = get(res, 'errors');
                    if (hasError) {
                      return Promise.reject(
                        new Error((errors || []).join(',')),
                      );
                      //</ItemWrapper>throw Error((errors || []).join(','));
                    }
                  }
                },
              },
            ]}>
            {(props, meta) => {
              const value = props.value;
              const onChange = props.onChange;
              const errors = get(meta, 'errors');
              return (
                <LinkLibrary
                  error={(errors || []).join(' ')}
                  data={value}
                  onChange={onChange}
                  linkSet={linkSet}
                />
              );
            }}
          </Field>
        </React.Fragment>
      );
    }
    if (type === MediaType.Video) {
      return (
        <React.Fragment>
          <Field name={imageBackground} valuePropName={'checked'}>
            <OriCheckbox className={css.checkbox}>
              {getI18n('salesChannelContent.index.setvideofileasabackground')}
            </OriCheckbox>
          </Field>
          <Field
            shouldUpdate={(p, c) => {
              return (
                get(p, `${imageBackground}`) !== get(c, `${imageBackground}`)
              );
            }}>
            {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
              const background = getFieldValue(imageBackground);
              return (
                <Field name={imageAutoplayEnabled} valuePropName={'checked'}>
                  <OriCheckbox className={css.checkbox} disabled={background}>
                    {getI18n('general.enableautoplay')}
                  </OriCheckbox>
                </Field>
              );
            }}
          </Field>

          <Field
            shouldUpdate={(p, c) => {
              return (
                get(p, `${imageBackground}`) !== get(c, `${imageBackground}`)
              );
            }}>
            {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
              const background = getFieldValue(imageBackground);
              return (
                <Field name={imageMute} valuePropName={'checked'}>
                  <OriCheckbox
                    className={css.checkboxLast}
                    disabled={background}>
                    {getI18n('general.playVideoonMute')}
                  </OriCheckbox>
                </Field>
              );
            }}
          </Field>
        </React.Fragment>
      );
    }

    return null;
  };
  return (
    <Section {...sectionProps}>
      <Field
        name={imageImage}
        rules={[
          {
            // validateTrigger: 'onSubmit',
            validator: async (rules: any, value: any) => {
              if (imageValidator) {
                const res = imageValidator(value, { breakpoint });

                const hasError = get(res, 'hasError');
                const errors = get(res, 'errors');
                if (hasError) {
                  return Promise.reject(new Error((errors || []).join(',')));
                  //</ItemWrapper>throw Error((errors || []).join(','));
                }
              }
            },
          },
        ]}>
        {(props, m) => {
          const e = itemWrapperErrorDisplayAdaptor(m);

          return (
            <ItemWrapper
              title={`${getI18n('general.tools_helper.image')}/${getI18n(
                'general.tools_helper.video',
              )}`}
              bottomTitle={`${getI18n(
                'general.allowedfiletypes',
              )}: jpeg, gif, png, mov, mp4`}
              size='small'
              {...e}>
              <Uploader height={180} type='Both' {...props} />
            </ItemWrapper>
          );
        }}
      </Field>

      <Field
        shouldUpdate={(p, c) => {
          return get(p, `${imageImage}`) !== get(c, `${imageImage}`);
        }}>
        {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
          const imageV = getFieldValue(imageImage);
          const type = mediaTypeCheck(imageV);

          return <React.Fragment>{renderUnderMedia(type)}</React.Fragment>;
        }}
      </Field>
    </Section>
  );
};
export default ImageAndVideo;
